/**
 * Settings General - AJAX Field Handler
 * Handles automatic saving of general settings fields that support per-item saves
 *
 * @author InterPals Development Team
 * @version 1.0.0
 */

(function() {
    'use strict';

    // Only run on settings pages with general section or no section specified
    var isSettingsPage = window.location.pathname.includes('/settings');
    var hasSection = window.location.search.includes('section=');
    var isGeneralSection = window.location.search.includes('section=general') || (!hasSection && isSettingsPage);

    if (!isSettingsPage || (hasSection && !isGeneralSection)) {
        return;
    }

    // Use shared helpers
    var helpers = window.SettingsHelpers;
    if (!helpers) {
        console.error('SettingsHelpers not loaded');
        return;
    }

    /**
     * Initialize timezone select field
     */
    function initTimezoneSelect() {
        var timezoneSelect = document.querySelector('select#tz');

        if (timezoneSelect) {
            timezoneSelect.addEventListener('change', function() {
                // Find the parent container
                var container = this.closest('.flex') ||
                                this.closest('[class*="flex-col"]') ||
                                this.closest('.space-y-2') ||
                                this.parentElement;
                helpers.sendFieldUpdate({
                    fieldName: 'tz',
                    fieldValue: this.value,
                    container: container
                });
            });
        }
    }

    /**
     * Initialize all general settings fields that support per-item saves
     */
    function initGeneralFields() {
        initTimezoneSelect();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initGeneralFields, 100);
        });
    } else {
        setTimeout(initGeneralFields, 100);
    }

})();